<template>
  <div :class="$style['wt-checkbox']">
      <el-checkbox v-if="isShowAll" :disabled="disabled" :indeterminate="isIndeterminate"  v-model="checkAll" @change="handleCheckAllChange" :class="$style['indeterminate-checkbox']" :label="allValue">{{allLable}}</el-checkbox>
      <el-checkbox-group :disabled="disabled" v-model="crrentValue" @change="change" :class="isShowAll?$style['has-select-all-checkbox']:''">
          <el-checkbox v-for="(item,index) in checkList" :key="index" :disabled="item.disabled" :label="item[valueName]||item[labelName]||item">{{item[labelName]||item[valueName]||item}}</el-checkbox>
      </el-checkbox-group>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'wt-checkbox'

export default {
  name: 'wt-checkbox',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    checkList: {
      type: Array,
      default: function () {
        return []
      }
    },
    value: {
      type: [Array, String],
      default: function () {
        return []
      }
    },
    valueName: {
      type: String,
      default: 'value'
    },
    labelName: {
      type: String,
      default: 'label'
    },
    isIndeterminate: {
      type: Boolean,
      default: false
    },
    allLable: {
      type: String,
      default: '全部'
    },
    allValue: {
      type: String,
      default: ''
    },
    // 是否需要向父组件传出父选项部分的
    isOutParentCheck: {
      type: Boolean,
      default: false
    },
    // 是否显示全选
    isShowAll: {
      type: Boolean,
      default: false
    },
    // 勾选子选项的时候，父选项是否被勾上
    isParentSelected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean
    }
  },
  data () {
    return {
      crrentValue: JSON.parse(JSON.stringify(this.value)) || [],
      checkAll: false,
      is_indeterminate: this.isIndeterminate
    }
  },
  watch: {
    value: {
      handler: function (val) {
        if (JSON.stringify(val) !== JSON.stringify(this.crrentValue)) {
          this.crrentValue = JSON.parse(JSON.stringify(val))
          console.log('val.indexOf(this.allValue)', val)
          console.log('this.allValue', this.allValue)
          val.forEach(item => {
            if (item === this.allValue) {
              this.checkAll = true
            }
          })
        }
      }
    },
    crrentValue: {
      handler: function (val) {
        let selected = JSON.parse(JSON.stringify(val)) || []
        if (this.isParentSelected && this.isOutParentCheck && selected.indexOf(this.allValue) < 0) {
          selected.push(this.allValue)
        }
        this.$emit('input', selected)
      }
    }
  },
  methods: {
    change (val) {
      this.$emit('change', val)
      if (this.isParentSelected) {
        this.checkAll = true
      }
    },
    handleCheckAllChange (val) {
      let checkList = []
      this.checkList.forEach(item => {
        checkList.push(item[this.valueName])
      })
      this.crrentValue = val ? checkList : []
      this.is_indeterminate = false
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.wt-checkbox{
    :global
    .el-checkbox{
        &.el-checkbox{
            margin-left: 0
        }
    }
}
.indeterminate-checkbox{
    // margin-bottom: 10px;
}
.has-select-all-checkbox{
    padding-left: 20px;
}
</style>
